import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2e6hcxcqv5: FaireBrandEntity = {
  token: "b_2e6hcxcqv5",
  type: "brand",
  name: "Masterpieces Puzzles",
  avatarUrl:
    "https://cdn.faire.com/fastly/ad9dc22d1c4cafd71b1987ae4146a11ec88aa08bee2e1a385b7ca52dfa902d86.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f552e5eec0f0a85e688d9e17d4e33faf520093834f5db114ba0b5e41fa1f4d0a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ad9dc22d1c4cafd71b1987ae4146a11ec88aa08bee2e1a385b7ca52dfa902d86.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f552e5eec0f0a85e688d9e17d4e33faf520093834f5db114ba0b5e41fa1f4d0a.jpeg",
  location: "Oro Valley, AZ, USA",
  minimumOrderDollars: 300,
  rating: 5,
  reviewCount: 389,
  isTopShop: true,
  isInsider: true,
  description:
    "For over 30 years, MasterPieces® has enjoyed making quality jigsaw puzzles and games, toys, do-it-yourself wood craft kits, and much more. As an American jigsaw puzzles company and game store, innovation and premium quality are the MasterPieces® hallmark. We create puzzles that are made from recycled paper and soy-based inks to ensure you have nothing less than the best. Our pledge as your trusted jigsaw puzzle company is to make top quality kids’ puzzles, 300pc EZGrip puzzles, 550pc puzzles, 750pc puzzles, 1000pc puzzles, 1000pc panoramic puzzles, 2000pc puzzles, and multi-pack puzzles for puzzlers of all ages. We also deliver quality games and toys, including Checkers, ‘Opoly, Shake n’ Score, and more. We partner with famous brands like CaseIH/Farmall, Caterpillar, Betty Boop, John Wayne, Hersheys, NCAA, NFL, NFLPA, NHL, MLB, Polar Express, Raggedy Ann & Andy, Saturday Evening Post’s Norman Rockwell, U.S. Army, and Wizard of Oz.\n\nIf you want to piece together a complex jigsaw or solve a fun brainteaser, look no further than MasterPieces®. Our products take family game night to the next level!",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:35:48.214Z",
    importedBy: "entity-db-cli",
  },
};
